/* Dropdayz — "Meer laden" op collectie- en zoekpagina's.

   Haalt de volgende pagina op en plakt de kaarten achter het bestaande
   raster, zodat je door de hele lijst scrolt zonder ooit een paginanummer
   aan te raken.

   SKELETKAARTJES (eigenaar, 19 aug 2026): tijdens het ophalen komen er nu
   grijze kaartjes met een glans eroverheen onderaan het raster te staan,
   in plaats van alleen een knop die "Laden..." zegt. De pagina wordt er niet
   sneller van, maar wel sneller aanvoelend: de vorm van het raster blijft
   staan en er gebeurt zichtbaar iets.

   DRIE ZOLEN IN DE KNOP (eigenaar, 19 aug 2026, keuze 5B): waar de knop
   eerst "Laden…" zei, stappen er nu drie schoenzolen om de beurt omhoog en
   kleuren daarbij blauw. Dezelfde functie als de drie stipjes die elke site
   heeft, maar dan van jullie. Kost niets extra: het zijn drie divjes met
   één keyframe, en de CSS zit al in de stylesheet die dit bestand toch al
   invoegt.
   De knop behoudt zijn afmetingen — de zolen komen op de plek van de tekst,
   dus het raster verspringt niet terwijl je wacht.

   Ze pakken de klassen over van een bestaande kaart, zodat ze automatisch in
   dezelfde kolommen vallen — ook als het raster op 4 of 5 kolommen staat.
   Het aantal is gelijk aan één rij, afgeleid uit de echte kolombreedte.
   De CSS wordt één keer door dit script zelf ingevoegd, zodat er geen extra
   bestand en geen regel in theme.liquid bij hoeft.

   NB: skeletten hebben GEEN nut bij filteren of sorteren — dat is in dit
   thema een gewone paginanavigatie (zie ddz-filters.js, die zet location).
   Ze verschijnen dus alleen hier.

   TWEE MODI, afhankelijk van data-sectie op de knop:
   - MET sectie-id (collectiepagina's): haalt alleen die sectie op via
     ?section_id=, dus zonder header, footer en apps — een stuk lichter.
   - ZONDER sectie-id (zoekpagina, want dat is een template en geen sectie):
     haalt de volledige pagina op en vist daar hetzelfde raster uit. Iets
     zwaarder, maar het werkt overal hetzelfde.

   ONTWERPREGELS
   - Gedelegeerd op document, dus de knop blijft werken nadat ddz-filters.js
     het raster heeft vervangen na een filter- of sorteeractie.
   - De echte paginalinks blijven altijd in de HTML staan voor zoekmachines
     en bezoekers zonder JavaScript; ze worden alleen verborgen zolang de
     knop het werk doet, en komen terug zodra een fetch mislukt.
   - Een MutationObserver op #Collection draait de opstart opnieuw na elke
     AJAX-wissel; de inline scripts van de sectie draaien daarna namelijk
     niet meer (innerHTML voert geen scripts uit).

   LET OP bij wijzigen: tel kinderen altijd met ':scope > li'. De eerste
   versie gebruikte '> li', wat geen geldige selector is; die gooide een
   fout midden in de succesafhandeling, waarna het vangnet de paginering
   weer tevoorschijn haalde en de teller op 0 bleef staan.

   En: herstel de knop in ELKE afloop — zowel bij succes als bij een mislukte
   fetch. Blijven de zolen staan, dan kijkt de bezoeker naar een knop die
   eeuwig laadt. */
(function () {
  'use strict';
  if (window.__ddzMeer) { return; }
  window.__ddzMeer = true;

  var SK_CSS = '.ddz-sk{ pointer-events:none; }' +
    '.ddz-sk__beeld{ aspect-ratio:1/1; border-radius:2px; background:#eceae5; }' +
    '.ddz-sk__r{ height:11px; border-radius:2px; background:#eceae5; margin-top:10px; }' +
    '.ddz-sk__r--kort{ width:52%; }' +
    '.ddz-sk__beeld,.ddz-sk__r{ background:linear-gradient(90deg,#eceae5 0%,#f6f5f2 40%,#eceae5 80%);' +
    ' background-size:280% 100%; animation:ddzSkGlans 1.4s linear infinite; }' +
    '@keyframes ddzSkGlans{ 0%{ background-position:120% 0; } 100%{ background-position:-120% 0; } }' +
    /* --- drie zolen in de laadknop --- */
    '.ddz-zolen{ display:inline-flex; gap:10px; align-items:center; vertical-align:middle; }' +
    '.ddz-zolen i{ display:block; width:11px; height:18px; border-radius:6px 6px 5px 5px;' +
    ' background:currentColor; opacity:.28; animation:ddzZoolStap .9s ease-in-out infinite; }' +
    '.ddz-zolen i:nth-child(2){ animation-delay:.15s; }' +
    '.ddz-zolen i:nth-child(3){ animation-delay:.3s; }' +
    '@keyframes ddzZoolStap{ 0%,100%{ opacity:.28; transform:translateY(0); }' +
    ' 40%{ opacity:1; transform:translateY(-5px); } }' +
    '@media (prefers-reduced-motion:reduce){ .ddz-sk__beeld,.ddz-sk__r{ animation:none; background:#eceae5; }' +
    ' .ddz-zolen i{ animation:none; opacity:.55; } }';

  function zorgVoorCss() {
    if (document.getElementById('ddz-sk-css')) { return; }
    var s = document.createElement('style');
    s.id = 'ddz-sk-css';
    s.textContent = SK_CSS;
    document.head.appendChild(s);
  }

  function kaartenIn(grid) {
    return grid ? grid.querySelectorAll(':scope > li') : [];
  }

  /* hoeveel kaarten passen er op één rij? afgeleid uit de echte breedtes,
     zodat het klopt of het raster nu op 3, 4 of 5 kolommen staat */
  function kolommen(grid) {
    var eerste = grid.querySelector(':scope > li');
    if (!eerste) { return 4; }
    var b = eerste.getBoundingClientRect().width;
    var g = grid.getBoundingClientRect().width;
    if (!b || !g) { return 4; }
    return Math.max(2, Math.min(6, Math.round(g / b)));
  }

  function toonSkeletten(grid) {
    zorgVoorCss();
    var voorbeeld = grid.querySelector(':scope > li');
    var klas = voorbeeld ? voorbeeld.className : 'grid__item';
    var n = kolommen(grid);
    var uit = [];
    for (var i = 0; i < n; i++) {
      var li = document.createElement('li');
      li.className = klas + ' ddz-sk';
      li.setAttribute('aria-hidden', 'true');
      li.innerHTML = '<div class="ddz-sk__beeld"></div><div class="ddz-sk__r"></div><div class="ddz-sk__r ddz-sk__r--kort"></div>';
      grid.appendChild(li);
      uit.push(li);
    }
    return uit;
  }

  function ruimSkeletten(lijst) {
    if (!lijst) { return; }
    lijst.forEach(function (el) {
      if (el && el.parentNode) { el.parentNode.removeChild(el); }
    });
  }

  /* de knop tijdens het laden: drie zolen in plaats van "Laden…".
     We bewaren de oorspronkelijke inhoud en de gemeten breedte, zodat de
     knop niet krimpt en de pagina niet verspringt. */
  function knopLaadt(knop) {
    zorgVoorCss();
    knop.setAttribute('data-ddz-tekst', knop.innerHTML);
    knop.style.minWidth = Math.ceil(knop.getBoundingClientRect().width) + 'px';
    knop.setAttribute('aria-busy', 'true');
    knop.innerHTML = '<span class="ddz-zolen" aria-hidden="true"><i></i><i></i><i></i></span>' +
                     '<span class="visually-hidden">Laden…</span>';
  }

  function knopKlaar(knop) {
    var oud = knop.getAttribute('data-ddz-tekst');
    if (oud !== null) { knop.innerHTML = oud; }
    knop.removeAttribute('data-ddz-tekst');
    knop.removeAttribute('aria-busy');
    knop.style.minWidth = '';
  }

  function werkStandBij() {
    var grid = document.querySelector('[data-ddz-grid]');
    var veld = document.querySelector('[data-ddz-meer-getoond]');
    if (grid && veld) {
      /* skeletten niet meetellen in de teller */
      var echt = 0;
      var alles = kaartenIn(grid);
      for (var i = 0; i < alles.length; i++) {
        if (!alles[i].classList.contains('ddz-sk')) { echt++; }
      }
      veld.textContent = echt;
    }
  }

  function start() {
    var paginering = document.querySelector('[data-ddz-paginatie]');
    var meer = document.querySelector('[data-ddz-meer]');
    if (paginering) { paginering.style.display = meer ? 'none' : ''; }
    werkStandBij();
  }

  function koppelObserver() {
    var host = document.getElementById('Collection');
    if (!host || !window.MutationObserver) { return; }
    new MutationObserver(function () { start(); })
      .observe(host, { childList: true });
  }

  function init() { start(); koppelObserver(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('[data-ddz-meer-knop]') : null;
    if (!knop || knop.disabled) { return; }
    e.preventDefault();

    var url = knop.getAttribute('data-url');
    var sectie = knop.getAttribute('data-sectie');
    if (!url) { return; }

    knop.disabled = true;
    knopLaadt(knop);

    var grid = document.querySelector('[data-ddz-grid]');
    var skeletten = grid ? toonSkeletten(grid) : null;

    var doel = url;
    if (sectie) {
      doel += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectie);
    }

    fetch(doel, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('status ' + r.status); }
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bron = doc.querySelector('[data-ddz-grid]');
        var g = document.querySelector('[data-ddz-grid]');
        if (!bron || !g) { throw new Error('geen raster in het antwoord'); }

        ruimSkeletten(skeletten);
        skeletten = null;

        var nieuw = kaartenIn(bron);
        for (var i = 0; i < nieuw.length; i++) {
          g.appendChild(document.importNode(nieuw[i], true));
        }

        var volgende = doc.querySelector('[data-ddz-meer-knop]');
        if (volgende) {
          knop.setAttribute('data-url', volgende.getAttribute('data-url'));
          knopKlaar(knop);
          knop.disabled = false;
        } else {
          var blok = knop.closest('[data-ddz-meer]');
          if (blok && blok.parentNode) { blok.parentNode.removeChild(blok); }
        }

        try { werkStandBij(); } catch (e) {}
        if (window.lazySizes && window.lazySizes.autoSizer) {
          try { window.lazySizes.autoSizer.checkElems(); } catch (e) {}
        }
      })
      .catch(function () {
        /* vangnet: skeletten weg, knop weer bruikbaar en de gewone
           paginalinks terug */
        ruimSkeletten(skeletten);
        knopKlaar(knop);
        knop.disabled = false;
        var p = document.querySelector('[data-ddz-paginatie]');
        if (p) { p.style.display = ''; }
      });
  });
})();
